import { createReducer } from '@core/utils/state';
import { LIST_COLUMN_IDS_SET } from '../../action-types';

export const listColumnReducer = createReducer({}, {

    [LIST_COLUMN_IDS_SET]: (state, { payload }) => {
        return { ...state, selectedColumnIds: [ ...(payload.columnIds || [])] };
    }

});
